import { useCallback } from 'react'

import { F0Icon } from '@factorialco/f0-react'
import { Widget as WidgetContainer, WidgetSection } from '@factorialco/f0-react/dist/experimental'
import { Clock, Crown, Target } from '@factorialco/f0-react/icons/app'

import { minutesToText } from 'modules/core/lib/duration'
import i18n from 'modules/core/lib/i18n'

interface Props {
  balance: number
  onClick: () => void
}

const BalanceCounter = ({ balance, onClick }: Props) => {
  const getBalanceDescription = useCallback(() => {
    if (balance === 0) {
      return {
        title: i18n.t('clock_in.balance_widget.on_target'),
        icon: Target,
      }
    }
    if (balance < 0) {
      return {
        title: i18n.t('clock_in.balance_widget.less_than_planned'),
        icon: Clock,
      }
    }
    return {
      title: i18n.t('clock_in.balance_widget.more_than_planned'),
      icon: Crown,
    }
  }, [balance])

  const { title, icon } = getBalanceDescription()

  return (
    <WidgetContainer
      header={{
        title: i18n.t('clock_in.balance_widget.title'),
        link: {
          title: i18n.t('clock_in.balance_widget.title'),
          onClick: onClick,
        },
      }}
    >
      <WidgetSection title={title}>
        <span className="flex items-center gap-2">
          <F0Icon icon={icon} size="lg" color="primary" />
          <span className="text-2xl text-f1-foreground font-semibold cursor-default">
            {minutesToText(balance, false, true)}
          </span>
        </span>
      </WidgetSection>
    </WidgetContainer>
  )
}

export default BalanceCounter
